import { render, staticRenderFns } from "./NewProductRelease.vue?vue&type=template&id=27a6ba26&scoped=true"
import script from "./NewProductRelease.vue?vue&type=script&lang=js"
export * from "./NewProductRelease.vue?vue&type=script&lang=js"
import style0 from "./NewProductRelease.vue?vue&type=style&index=0&id=27a6ba26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a6ba26",
  null
  
)

export default component.exports